import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';

import RootLayout from './pages/RootLayout';
import ErrorPage from './pages/ErrorPage';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import ProjectsPage from './pages/ProjectsPage';
import BookMeeting from './pages/BookMeeting';
import AINotetakerPage from './pages/AINotetakerPage';

ReactGA.initialize('G-2F3L55F41P');

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'projects', element: <ProjectsPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'book-meeting', element: <BookMeeting /> },
      { path: 'note', element: <AINotetakerPage /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
